import { post, read } from '@/utils/request'
import type { ListData } from 'bv-typings'
import type { GoogleBatchType, IGoogleBatchInfo } from '@/types/batch/google'
import { isArray } from 'bv-validator'
import { getQuery, onErrorNotice } from 'bv-utils'
import { toggleTime } from '@/utils'

export const categoryMap = {
  recharge: 1, // 额度管理
  rename: 2, // 账户更名
  invite: 3, // Mcc邀请
  permission: 4, // 授权个人账户
  transfer: 5, // Mcc转移
}

const getCategory = (params: any, type: any) => ({ ...params, category: categoryMap[type] })

export type IGetGoogleBatchListParams = {
  category: number  // 类型
  accountIds: string // 多选
  accountName: string
  accountStatus: number
  status: number
  applyId: string
  submitter: string
  dateRange: string
  urgent: number // 充值,Mcc邀请,授权个人账户
  chargeType: number// 充值
  mccType: number// Mcc邀请
  userRoleType: number// 授权个人账户
}

export type IGoogleBatchListRes = ListData<IGoogleBatchInfo>

const getList = (params?: IGetGoogleBatchListParams, type?: GoogleBatchType) => read<IGoogleBatchListRes>(
  'google_batch_process/handle_list',
  // getCategory(params ?? getQuery(), type),
  toggleTime(getCategory(params ?? getQuery(), type), 'date', 'startTime', 'endTime'),
)

export type IGetUnconfirmed = {
  unconfirmedSpend: string  // 额度管理
  unconfirmedRename: string // 重命名
  unconfirmedMccLink: string // mcc邀请
  unconfirmedMccTrans: string // mcc 转移
  unconfirmedUserRole: string // 个人账户管理
}

const getUnconfirmed = () => read<IGetUnconfirmed>(
  'google_batch_process/unconfirmed_count',
  undefined,
  '查询待办失败',
)

const batchConfirm = (params: any, type?: GoogleBatchType) => post(
  'google_batch_process/batch_confirm',
  getCategory(params, type),
  '批量确认失败',
)

const batchReject = (params?: any, type?: GoogleBatchType) => post(
  'google_batch_process/batch_reject',
  getCategory(params, type),
  '批量驳回失败',
)

const batchDelete = async (params: any, type?: GoogleBatchType) => post(
  'google_batch_process/batch_delete',
  getCategory(params, type),
  '批量删除失败',
)

const batchOperate = async (params: any, type?: GoogleBatchType) => post(
  'google_batch_process/batch_operate',
  getCategory(params, type),
  '批量处理失败',
)

const batchManualOperate = async (params: any, type?: GoogleBatchType) => post(
  'google_batch_process/batch_manual_confirm',
  getCategory({ data: params }, type),
  '手动确认失败',
)

const batchInitiate = (params: any, type: GoogleBatchType, signal?: any) => post(
  'google_batch_process/batch_handle',
  getCategory({ data: params }, type),
  undefined,
  undefined,
  { signal },
)

const singleInitiate = async (data: any, type: GoogleBatchType) => {
  const [ res, error ] = await batchInitiate([ { ...data, index: 0 } ], type)
  const localeError = isArray(error) ? error[0]?.errorInfo : error?.toString()
  if (localeError) {
    onErrorNotice('创建申请失败', localeError)
  }
  return [ res, localeError ]
}

export type IGetGoogleAccountInfo = {
  accountId: string
  accountName: string
  accountStatus: number
  // 额度管理
  oldApprovedSpendingLimit: number,
  invalidClick: number,
  // 授权个人账户
  userRoleLevel: number,
  // Mcc转移
  inMcc: string,
}

const getAccountInfo = (accountId?: string) => read<IGetGoogleAccountInfo>(
  'google_batch_process/get_account_detail',
  undefined,
  '获取账户信息失败',
  accountId,
)


const getAccountsInfo = (params?: { index: number, accountId: string }[], type?: string, signal?: any) => post<IGetGoogleAccountInfo[]>(
  'google_batch_process/get_account_details',
  getCategory({ data: params }, type),
  undefined,
  undefined,
  { signal },
)

export {
  getList,
  getUnconfirmed,
  batchConfirm,
  batchReject,
  batchDelete,
  batchInitiate,
  batchOperate,
  batchManualOperate,
  getAccountInfo,
  getAccountsInfo,
  singleInitiate,
}
